import React from 'react'
import ReactDOM from 'react-dom'
import App from './router'
import './index.less'
import reportWebVitals from './reportWebVitals'
import '../../shenmapws/src/common/i18n/config'
import { ScreenWidthProvider } from './ScreenWidthContext'

ReactDOM.render(
  <React.StrictMode>
    <ScreenWidthProvider>
    <App />
    </ScreenWidthProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
